import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useSetTrendingDeal = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const setTrendingDealMutation = useMutation(
    (productId) =>
      axios.put(
        `${process.env.REACT_APP_SERVER_URL}/product/products/set-trending-deal/${productId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("products");
      },
    }
  );

  const setTrendingDeal = async (productId) => {
    try {
      await setTrendingDealMutation.mutateAsync(productId);
    } catch (error) {
      console.error("Error setting trending deal:", error);
      throw error;
    }
  };

  return { setTrendingDeal, isLoading: setTrendingDealMutation.isLoading };
};

export default useSetTrendingDeal;
